import FeltoltesTesztlapDto from 'app/admin/feltoltestesztlap/dto/FeltoltesTesztlapDto';
import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';

class FeltoltesTesztlapTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'tesztlapUploadTableControl';
	}

	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, FeltoltesTesztlapDto)))
				.catch(reject);
		});
	}
}

export default new FeltoltesTesztlapTableService();
